import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';

import './discovery-creators-results-empty.scss';

applyTranslations(require('./discovery-creators-results-empty.i18n.json'));

type Props = {
  onResetFilters: () => void
};

const msgKey = 'discovery_creators_results_empty';

const DiscoveryCreatorsResultsEmpty = (
  {
    onResetFilters
  }: Props
): JSX.Element => (
  <div className="discovery-creators-results-empty">
    <div className="discovery-creators-results-empty__message">
      {__t(`${msgKey}.messages.no_results`)}
    </div>
    <div className="discovery-creators-results-empty__button">
      <ActionButton onClick={onResetFilters}>
        {__t(`${msgKey}.buttons.reset`)}
      </ActionButton>
    </div>
  </div>
);

export default DiscoveryCreatorsResultsEmpty;
